import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { isInternationalShipTo } from '@/shared/utils/shipToCountry';
import { OrderContext } from '../../contexts/OrderContext';
import InternationalOrderIcon from '../shared/InternationalOrderIcon';
import type { ShipstationOrder } from '../../types/apiTypes';
import { getOrderItemCount, getOrderStatusFlairs } from './orderSearchUtils';
import type { OrderDetailNavState } from './orderdetail/orderDetailNavState';
import './OrdersList.css';

interface OrderBoxProps {
  order: ShipstationOrder;
  tagDictionary: Record<string, string | number>;
  navState: OrderDetailNavState;
}

function OrderBox({ order, tagDictionary, navState }: OrderBoxProps): React.ReactElement {
  const context = useContext(OrderContext);
  const {
    setSelectedOrderId,
    setOrderItems,
    setShipToName,
  } = context!;

  const handleOrderClick = (orderId: string | number): void => {
    setSelectedOrderId(orderId);
    setOrderItems([]);
    setShipToName('');
  };

  const { holdOrder, clearToFulfill } = getOrderStatusFlairs(order, tagDictionary);
  const componentCount = getOrderItemCount(order);
  const isInternational = isInternationalShipTo(order.shipTo);
  const orderNumberToneClass = holdOrder
    ? 'order-box-order-number--hold'
    : clearToFulfill
      ? 'order-box-order-number--clear'
      : '';

  const orderLink = (
    <Link
      className="order-box-container"
      to={`/order/${order.orderId}`}
      state={navState}
      onClick={() => handleOrderClick(order.orderId)}>
      <div className="order-box-content">
        <span className={['order-box-order-number', orderNumberToneClass].filter(Boolean).join(' ')}>
          {order.orderNumber}
        </span>
        {isInternational && (
          <InternationalOrderIcon className="order-box-international-icon" />
        )}
        <span className="order-box-customer-name">{order.shipTo?.name}</span>
      </div>
      <div className="order-flair-container">
        <div
          className="order-box-component-count"
          aria-label={`${componentCount} components`}
        >
          {componentCount}
        </div>
        <div
          className="order-box-flair"
          style={{ backgroundColor: holdOrder ? '#FF0000' : 'transparent' }}
        />
        <div
          className="order-box-flair"
          style={{ backgroundColor: clearToFulfill ? '#1eb01e' : 'transparent' }}
        />
      </div>
    </Link>
  );

  return (
    <li>
      {orderLink}
    </li>
  );
}
export default OrderBox;
